function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { createElementHook, createElementObject, createLayerHook, updateMediaOverlay } from "@manifesto-tech/react-leaflet-core";
import { SVGOverlay as LeafletSVGOverlay } from "leaflet";
import { forwardRef, useImperativeHandle } from "react";
import { createPortal } from "react-dom";
export var useSVGOverlayElement = createElementHook(function createSVGOverlay(props, context) {
    var attributes = props.attributes, bounds = props.bounds, options = _objectWithoutProperties(props, [
        "attributes",
        "bounds"
    ]);
    var container = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    container.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    if (attributes != null) {
        Object.keys(attributes).forEach(function(name) {
            container.setAttribute(name, attributes[name]);
        });
    }
    var overlay = new LeafletSVGOverlay(container, bounds, options);
    return createElementObject(overlay, context, container);
}, updateMediaOverlay);
export var useSVGOverlay = createLayerHook(useSVGOverlayElement);
function SVGOverlayComponent(_param, forwardedRef) {
    var children = _param.children, options = _objectWithoutProperties(_param, [
        "children"
    ]);
    var _useSVGOverlay_current = useSVGOverlay(options).current, instance = _useSVGOverlay_current.instance, container = _useSVGOverlay_current.container;
    useImperativeHandle(forwardedRef, function() {
        return instance;
    });
    return container == null || children == null ? null : /*#__PURE__*/ createPortal(children, container);
}
export var SVGOverlay = /*#__PURE__*/ forwardRef(SVGOverlayComponent);
